export default __webpack_public_path__ + "static/media/onroad-laundry.8298192c.jpeg";